import { max, min } from "lodash";
import { ServiceFormValues } from "../service-management-type";

export const ServiceCategories = [
  {
    value: "Funeral & Memorial Service Providers",
    label: "Funeral & Memorial Service Providers",
  },
  {
    value: "Preneed Planner",
    label: "Preneed Planner",
  },
  { value: "Aftercare & Grief Support", label: "Aftercare & Grief Support" },
  {
    value: "Transportation & Logistics",
    label: "Transportation & Logistics",
  },
  { value: "Products & Supplies", label: "Products & Supplies" },
  {
    value: "Cremation Services",
    label: "Cremation Services",
  },
  { value: "Technology & Media", label: "Technology & Media" },
  {
    value: "Religious & Cultural Services",
    label: "Religious & Cultural Services",
  },
  {
    value: "Vendor Services",
    label: "Vendor Services",
  },
];

export const subServiceHeaders = [
  { key: "name", label: "Sub-Service Name" },
  { key: "price", label: "Base Price" },
  { key: "status", label: "Status" },
  { key: "actions", label: "Actions" },
];

export const merchandiseHeaders = [
  { key: "name", label: "Merchandise Name" },
  { key: "price", label: "Base Price" },
  { key: "status", label: "Status" },
  { key: "actions", label: "Actions" },
];

export const serviceFormInitialValues: ServiceFormValues = {
  name: "",
  code: "",
  description: "",
  category: [],
  status: true,
  minPrice: 0,
  maxPrice: 0,
  taxApplicable: false,
  commissionPercent: 0,
  commissionValue: 0.0,
  subServices: [],
  merchandises: [],
};

export const formatPayloadForService = (data: any) => {
  return {
    name: data.name || "",
    code: data.code || "",
    description: data.description || "",
    categoryIds: data.categoryIds || [],
    minPrice: data.minPrice || 0,
    maxPrice: data.maxPrice || 0,
    taxApplicable: data.taxApplicable || false,
    commissionPercentage: data.commissionPercent || 0,
    commissionFixed: data.commissionValue || 0.0,
    subServices: data.subServices.map((subService: any) => ({
      id: subService.id,
      name: subService.name || "",
      description: subService.description || "",
      minPrice: subService.minPrice,
      maxPrice: subService.maxPrice,
      isActive: subService.status === "active" || subService.status === true ? true : false,
    })),
    merchandises: data.merchandises.map((merchandise: any) => ({
      id: merchandise.id,
      name: merchandise.name || "",
      code: merchandise.code || "",
      description: merchandise.description || "",
      minPrice: merchandise.minPrice,
      maxPrice: merchandise.maxPrice,
      isActive: merchandise.status === "active" || merchandise.status === true ? true : false,
    })),
    isActive: (data.status === "active" || data.status === true) ? true : false,
  };
};

export const formatCurrency = (amount: number) => {
    if(typeof amount !== 'number') {
      return "";
    }
    return `${amount.toFixed(2)}`;
}